export type DAYS =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const DEFAULT_TIME_SLOT: TimeSlot = {
  startTime: '09:00',
  endTime: '17:00',
  enabled: false,
};
export const BUSINESS_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

export interface WorkingHour {
  id?: number;
  resourceId?: number;
  orgId?: string;
  day: DAYS | string;
  startTime: string;
  enabled?: boolean;
  isModified?: boolean;
  endTime: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TimeSlot {
  startTime: string;
  endTime: string;
  enabled?: boolean;
  id?: number;
  isModified?: boolean;
}

export interface WorkingHours {
  [key: string]: TimeSlot[];
}

export interface WorkingHoursFormData {
  workingHours: WorkingHours;
}

export interface WorkingHoursState {
  items: WorkingHour[];
  orgWorkingHours: Partial<WorkingHour>[];
  settingsOrgWorkingHours: WorkingHours;
  isLoading: boolean;
  error: string | null;
}
